var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CMS',{attrs:{"contents_type":"block_contents","location_code":"CRPG_TOP_99_001-footer"}})}
var staticRenderFns = []

export { render, staticRenderFns }